/* v8 ignore start */

import type { FunctionComponent } from 'react'

import { GamPanel } from '../../../../shared'
import { usePageGamConfig } from '../../../../shared/hooks/usePageGamConfig'
import type { PageInfo } from '../../../../shared/types'
import styles from './NewsFooterGam.module.scss'

type Props = { pageInfo: PageInfo }

export const NewsFooterGam: FunctionComponent<Props> = ({ pageInfo }) => {
  const gamConfig = usePageGamConfig({ pageInfo })

  if (gamConfig === undefined) {
    return null
  }

  return (
    <div className={styles.newsGamWrapper}>
      <GamPanel
        {...gamConfig}
        gamId="div-gpt-ad-6221233-2"
        panelName="newsVerticalFooter"
        path="/30585109/cdn/news/news/news/news-home"
        slotSize={[300, 250]}
        sizeMappings={[
          [[1270, 0], [[600, 250]]],
          [[375, 0], [[300, 250]]],
        ]}
      />
    </div>
  )
}

/* v8 ignore stop */
